import React from 'react';
import PropTypes from 'prop-types';
import { AiOutlineUser } from 'react-icons/ai';

import { Container } from './styles';
import { Image } from '../ImagePicker/styles';

export default function Avatar({ children, image, size, ...rest }) {
  return (
    <Container size={size} {...rest}>
      {image ? <Image src={image} /> : children}
    </Container>
  );
}

Avatar.propTypes = {
  children: PropTypes.any,
  size: PropTypes.string,
  image: PropTypes.string,
};
Avatar.defaultProps = {
  children: <AiOutlineUser />,
  size: '30px',
  image: null,
};
